import {Injectable} from '@angular/core';
import {CrudBaseService} from "./crud-base.service";
import {MarcacaoModel, MarcacaoPrimaryKey} from "../models/marcacao.model";
import {HttpClient} from "@angular/common/http";
import {IPrimaryKey} from "../interfaces/iprimary-key";
import {MedicoModel, MedicoPrimaryKey} from "../models/medico.model";

@Injectable({
  providedIn: 'root'
})
export class MarcacaoService extends CrudBaseService<MarcacaoModel> {

  constructor(http: HttpClient) {
    super(http, 'marcacao');
  }

  public getPk(id: IPrimaryKey<MarcacaoModel>): MarcacaoPrimaryKey {
    return Object.assign(new MarcacaoPrimaryKey(), id);
  }

  public getAllAgendadosByMedico(medicoId: IPrimaryKey<MedicoModel>) {
    let medicoPk = Object.assign(new MedicoPrimaryKey(), medicoId);
    return this.getAllByUrlQuery<MarcacaoModel>(`profissional/${medicoPk.id}`);
  }

  public getAllRealizadasBySeqBeneficiario(seqBeneficiario: number) {
    return this.getAllByUrlQuery<MarcacaoModel>(`realizadas/usuario/${seqBeneficiario}`);
  }

  public getAllAvulsosByFiltros(nomePaciente: string | undefined,
                                         dtNascimento: Date | undefined,
                                         dtAgendada: Date | undefined,
                                         dtAtendimento: Date | undefined,
                                         cpf: string | undefined,
                                         medico: MedicoPrimaryKey | undefined) {
    let queryData: string[] = [];

    if (nomePaciente) {
      queryData.push(`nomePaciente=${nomePaciente}`);
    }

    if (dtNascimento) {
      queryData.push(`dtNascimento=${dtNascimento}`);
    }

    if (dtAgendada) {
      queryData.push(`dtAgendada=${dtAgendada.toISOString().split('T')[0]}`);
    }

    if (dtAtendimento) {
      queryData.push(`dtAtendimento=${dtAtendimento}`);
    }

    if (cpf) {
      queryData.push(`cpf=${cpf}`);
    }

    if (medico) {
      queryData.push(`tipoConselho=${medico.tipo_Conselho}`);
      queryData.push(`siglaUf=${medico.sigla_UF}`);
      queryData.push(`numConselho=${medico.num_Conselho}`);
    }

    let query = `filtro?${queryData.join('&')}`;
    return this.getAllByUrlQuery<MarcacaoModel>(query);
  }
}
